import { getRoot } from 'mobx-state-tree'
import { SocialReferent } from '@shared/data-access'

export const MODEL_NAME = 'AvailableSR'

export const Model = SocialReferent.named(MODEL_NAME).volatile((self) => ({
  _store: getRoot(self)[`${MODEL_NAME}Store`],
}))
